import type { GetServerSideProps } from "next";
import getRequestedCustomDomain from "../lib/get-requested-custom-domain";
import loadPublicCompanies from "../lib/load-public-companies";
import sendSitemapXmlIndex from "../lib/send-sitemap-xml-index";
import { getServerSideProps as originalGetServerSideProps } from "./[companySlug]/sitemap.xml";

export { default } from "./[companySlug]/sitemap.xml";

export const getServerSideProps: GetServerSideProps =
  async function getServerSideProps(context) {
    if (getRequestedCustomDomain(context)) {
      return originalGetServerSideProps(context);
    }

    const companies = await loadPublicCompanies();
    const base = context.req.headers.host || "";

    const sites = companies.map((slug) => `${base}/${slug}`);

    sendSitemapXmlIndex(context.res, sites);
    return { props: {} };
  };
